import React from 'react'
import FormFlex from '../../../gd-form/form/form-flex/form';
import FieldFormElement from "../../../fields3/render/form-elemnent";
// import ButtonSubmit from "../../../gd-form/common/btn-submit/btn-submit-ui5";
import FormModel from "../../../gd-form/common/form-model-manager";
import TimeReport from "../../../model2/time-report/time-report";
import FieldViewReference from "../../../fields3/render/view-reference";
import FormRowFlex from '../../../gd-form/form/form-flex/row';
import ErrorBoundary from "../../../error-boundary";
import ApiTimeReport from "../../../gd/api/time-reports/time-report";
import VScroll from "../../../gd-components/scrolling/custom-v-scroll/v-scroll";
import {ModalCreateTimeReportProps} from "./modal-create-time-report";
import Button, {ButtonSize, ButtonType} from "../../../gd-components/buttons/gd-button/gd-button-ui5-new";
import ButtonSubmit from "../../../gd-form/common/btn-submit/btn-submit-ui5-new";

// type State = {
//     currentView?: string
// }

type Props = {
    className?  : string,
    callback    : callback
    params      : ModalCreateTimeReportProps
}

export default class ModalNewTimeReport_Form extends React.Component<Props> {

    private readonly form       : FormModel
    private timeReport          : TimeReport

    constructor(props: Props) {
        super(props);

        this.timeReport = new TimeReport({
            userId      : _.get(props.params, 'userId', gd.user.id),
            date        : _.get(props.params, 'date', moment()),
            task        : this.props.params.task,
            taskId      : this.props.params.task.id,
            taskMessageId       : _.get(props.params, 'taskMessageId', null),
            // isBillable          : true, // hmmmm.... nothing here - it will tak default for companyu

            reportedTimeMinutes : _.get(props.params, 'reportedTimeMinutes', undefined),
            startMoment         : _.get(props.params, 'startMoment', undefined),
            endMoment           : _.get(props.params, 'endMoment', undefined)
        })

        this.form = new FormModel(this.timeReport,{
            onSubmit        : this.onSubmit,
        })

        this.form.onFieldChanged(gd.fields.timeReport.startMoment.fieldId,()=>{
            this.forceUpdate()
        })
        this.form.onFieldChanged(gd.fields.timeReport.endMoment.fieldId,()=>{
            this.forceUpdate()
        })

        this.form.onFieldChanged(gd.fields.timeReport.reportedTimeMinutes.fieldId,()=>{
            this.forceUpdate()
        })

    }

    public onSubmit = async () => {

        let response : any

        if (this.timeReport.taskMessageId) {
            response = await ApiTimeReport.createForTaskMessage(
                this.timeReport.taskMessageId,
                this.timeReport.reportedTimeMinutes,
                // @ts-ignore
                this.timeReport.startMoment,
                this.timeReport.endMoment
            )

        } else {
            // response = await ApiTimeReport.createForTask(
            //     this.timeReport.taskId,
            //     this.timeReport.date as Moment,
            //     this.timeReport.reportedTimeMinutes,
            //     this.timeReport.userId,
            //     this.timeReport.message,
            //     null,
            //     _.get(this.props.params, 'needMyTimeResponse', false),
            //     // @ts-ignore
            //     this.timeReport.startMoment,
            //     this.timeReport.endMoment
            // )
            const needMyTimeResponse : boolean =  _.get(this.props.params, 'needMyTimeResponse', false)

            response = await ApiTimeReport.create(this.timeReport, needMyTimeResponse)
        }

        gd.modal.hide()
        if (this.props.callback) this.props.callback(response, this.timeReport)
    }

    public reRender = () => {
        this.forceUpdate()
    }

    cancelTimer = () => {
        this.props.params.timer!.cancel()
    }


    render() {

        const width : number = 175

        return (
            <div className="iv-content with-left-panel">

                <div className="ui5-title-app-name m-l-30 m-t-15 lh-30">New Time Report</div>

                <VScroll className="content-scroll">
                    <FormFlex className="m-t-30 p-l-30 p-r-30 m-b-50">

                        <FormRowFlex label="Task" elementClass="w-300" width={width} form={this.form}>
                            <FieldViewReference field={gd.fields.timeReport.task} model={this.timeReport} />
                        </FormRowFlex>

                        <ErrorBoundary>
                            <FormRowFlex width={width} field={gd.fields.timeReport.reportedTimeMinutes} form={this.form}>
                                <FieldFormElement field={gd.fields.timeReport.reportedTimeMinutes} form={this.form} className="w-300" model={this.timeReport} options={{displayStartEnd: false}} />
                            </FormRowFlex>
                        </ErrorBoundary>

                        <FormRowFlex label="Start/End" width={width} form={this.form} fieldHelp="Enter start and end time for the reported activity. Optional.">
                            <FieldFormElement field={gd.fields.timeReport.startMoment} form={this.form} model={this.timeReport} className="w-140" />
                            <div className="w-20 flex-row-center-center ui5-txt-not-important">-</div>
                            <FieldFormElement field={gd.fields.timeReport.endMoment} form={this.form} model={this.timeReport} className="w-140" />
                        </FormRowFlex>

                        {/*if task message specified we add time report to existing message */}
                        {!this.timeReport.taskMessageId && <>

                            <FormRowFlex label="Report date" width={width} field={gd.fields.timeReport.date} form={this.form}>
                                <FieldFormElement field={gd.fields.timeReport.date} form={this.form} className="w-300" />
                            </FormRowFlex>
                        </>}

                        {gd.modules.timeTracking.isBillableTimeEnabled &&
                            <FormRowFlex width={width} field={gd.fields.timeReport.isBillable} form={this.form}>
                                <FieldFormElement field={gd.fields.timeReport.isBillable} form={this.form} className="w-300" />
                            </FormRowFlex>
                        }

                        {!this.timeReport.taskMessageId && <>

                            {/* disabled with timer - as it makes no sense to use timer for other person */}
                            {!this.props.params.timer &&
                                <FormRowFlex width={width} field={gd.fields.timeReport.userId} form={this.form}>
                                    <FieldFormElement field={gd.fields.timeReport.userId} form={this.form} className="w-300" />
                                </FormRowFlex>
                            }

                            <FormRowFlex field={gd.fields.timeReport.message} width={width} form={this.form}>
                                <FieldFormElement field={gd.fields.timeReport.message} form={this.form} className="w-300" />
                            </FormRowFlex>
                        </>}

                        <FormRowFlex label="" width={width} description="" className="m-t-30">
                            <ButtonSubmit form={this.form} size={ButtonSize.STANDARD} label="Submit" className="w-125" />

                            {this.props.params.timer &&
                                <Button type={ButtonType.SECONDARY_RED} size={ButtonSize.STANDARD}
                                        onClick={this.cancelTimer}
                                        label="Cancel Timer" className="m-l-20 w-125" />
                            }


                        </FormRowFlex>

                        {/*{this.props.params.timer && (*/}
                        {/*    <FormRowFlex label="" width={width} description="" className="m-t-0">*/}
                        {/*        <Button type={ButtonType.SECONDARY_RED} size={ButtonSize.STANDARD} label="Cancel Timer" />*/}
                        {/*    </FormRowFlex>*/}
                        {/*)}*/}

                    </FormFlex>
                </VScroll>
            </div>
        )
    }
}
